import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RetirementCalculator from '../dashboard/landing-pages/RetirementCalculator';
import AnnuityGuide from '../dashboard/landing-pages/AnnuityGuide';
import AnnuityQuiz from '../dashboard/landing-pages/AnnuityQuiz';
import WebinarRegistration from '../dashboard/landing-pages/WebinarRegistration';
import ConsultationBooking from './ConsultationBooking';
import NewsletterSignup from './NewsletterSignup';
import TaxPreparation from './TaxPreparation';
import FuneralTrustTemplate from './FuneralTrustTemplate';
import RadioShowTemplate from './RadioShowTemplate';
import TaxReturnSeminar from './TaxReturnSeminar';

const LandingPages: React.FC = () => {
  return (
    <Routes>
      <Route path="retirement-calculator" element={<RetirementCalculator />} />
      <Route path="annuity-guide" element={<AnnuityGuide />} />
      <Route path="annuity-quiz" element={<AnnuityQuiz />} />
      <Route path="webinar-registration" element={<WebinarRegistration />} />
      <Route path="consultation-booking" element={<ConsultationBooking />} />
      <Route path="newsletter-signup" element={<NewsletterSignup />} />
      <Route path="tax-preparation" element={<TaxPreparation />} />
      <Route path="funeral-trust" element={<FuneralTrustTemplate />} />
      <Route path="radio-show" element={<RadioShowTemplate />} />
      <Route path="tax-return-seminar" element={<TaxReturnSeminar />} />
    </Routes>
  );
};

export default LandingPages;